/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Contract, ContractFactory, testMethod, fetchContractState, ContractInstance, } from "@alephium/web3";
import { default as GovernanceV1ContractJson } from "../tests/GovernanceV1.ral.json";
class Factory extends ContractFactory {
    constructor() {
        super(...arguments);
        this.tests = {
            foo: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "foo", params);
            }),
        };
    }
    at(address) {
        return new GovernanceV1Instance(address);
    }
}
// Use this object to test and deploy the contract
export const GovernanceV1 = new Factory(Contract.fromJson(GovernanceV1ContractJson, "", "237ca92e965dc50e86cb94535a4ffc9c9074ee6a7f1a1a24374f7380c6416d99"));
// Use this class to interact with the blockchain
export class GovernanceV1Instance extends ContractInstance {
    constructor(address) {
        super(address);
    }
    fetchState() {
        return __awaiter(this, void 0, void 0, function* () {
            return fetchContractState(GovernanceV1, this);
        });
    }
}
